import React, { useCallback, useEffect, useState } from "react";
import { Modal, Table, Typography } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";
import { getMySubscriptionDetails, getPurchaseHistory } from "../../components/redux/subscriptionSlice";

const { Text } = Typography;

const currency = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" });

const formatDate = (value) => {
  const m = moment(value);
  return m.isValid() && m.year() > 1 ? m.format("MMM D, YYYY") : null;
};

const columns = [
  { title: "Plan", dataIndex: "subscriptionName" },
  {
    title: "Date paid",
    key: "date",
    render: (_, row) => formatDate(row.paidOn) || formatDate(row.startDate) || "-",
  },
  { title: "Amount", dataIndex: "totalAmount", render: (v) => currency.format(v ?? 0) },
  { title: "Months", dataIndex: "noMonths" },
];

export default function PurchaseHistoryModal({ open, onClose }) {
  const dispatch = useDispatch();
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(null);

  const loadPage = useCallback(
    async (page) => {
      setLoading(true);
      const result = await dispatch(getPurchaseHistory(page));
      setHistory(getPurchaseHistory.fulfilled.match(result) ? result.payload : null);
      setLoading(false);
    },
    [dispatch],
  );

  useEffect(() => {
    if (!open) return;
    loadPage(1);
    dispatch(getMySubscriptionDetails()).then((result) => {
      setCurrent(getMySubscriptionDetails.fulfilled.match(result) ? result.payload : null);
    });
  }, [open, loadPage, dispatch]);

  return (
    <Modal open={open} onCancel={onClose} footer={null} title="Purchase history" width={680} destroyOnClose>
      {current?.plan && (
        <div style={{ marginBottom: 16, padding: "12px 16px", background: "#f0f4fa", borderRadius: 8 }}>
          <Text type="secondary">Current plan</Text>
          <div style={{ fontWeight: 600, fontSize: 15 }}>{current.plan.subscriptionName}</div>
          <Text type="secondary">
            {formatDate(current.userSubscription?.startDate) &&
              `Started ${formatDate(current.userSubscription.startDate)}`}
            {current.totalCredits > 0 && ` · Includes ${current.totalCredits} appointments`}
          </Text>
        </div>
      )}
      <Table
        rowKey="id"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={history?.data ?? []}
        locale={{ emptyText: "You haven't purchased a care plan yet." }}
        pagination={{
          current: history?.currentPage ?? 1,
          pageSize: history?.pageSize ?? 10,
          total: history?.totalRecords ?? 0,
          hideOnSinglePage: true,
          onChange: loadPage,
        }}
      />
    </Modal>
  );
}
